import React from "react";
import NavBar from "../components/NavBar";
import RentalPropertyPage from "../components/RentalPropertyPage";
import Footer from "../components/Footer";

const RentAProperty = () => {
    return(
        <div>
            <NavBar/>
            <RentalPropertyPage/>
            <Footer/>
        </div>
    )
}

export default RentAProperty;